import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate, ROLE_LABELS } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NONE = "__none__";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const load = () => { api.get("/users").then((r) => setUsers(r.data)); api.get("/organizations/public").then((r) => setOrgs(r.data)); };
  useEffect(() => { load(); }, []);
  const change = async (u, role) => { try { await api.put(`/users/${u.id}/role`, { role }); toast.success(`${u.name} is now ${ROLE_LABELS[role]}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  const assign = async (u, orgId) => { try { await api.put(`/users/${u.id}/organization`, { organization_id: orgId === NONE ? null : orgId }); toast.success("Organisation updated"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-6" data-testid="users-page">
      <div><p className="eyebrow">Administration</p><h1 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900 mt-1">Users & roles</h1></div>
      <div className="clinical-card divide-y divide-slate-100" data-testid="users-table">
        {users.map((u) => (
          <div key={u.id} className="p-4 flex flex-wrap items-center gap-4" data-testid={`user-row-${u.id}`}>
            <span className="w-9 h-9 rounded-full bg-teal-50 text-teal-800 grid place-items-center font-bold">{u.name?.[0]}</span>
            <div className="flex-1 min-w-[200px]"><p className="font-medium text-slate-900">{u.name}</p><p className="text-xs text-slate-500">{u.email} · joined {fmtDate(u.created_at)}</p></div>
            <Select value={u.organization_id || NONE} onValueChange={(v) => assign(u, v)}><SelectTrigger data-testid={`user-org-select-${u.id}`} className="w-56"><SelectValue placeholder="No organisation" /></SelectTrigger>
              <SelectContent className="bg-white"><SelectItem value={NONE}>No organisation</SelectItem>{orgs.map((o) => <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>)}</SelectContent></Select>
            <Select value={u.role} onValueChange={(v) => change(u, v)}><SelectTrigger data-testid={`user-role-select-${u.id}`} className="w-40"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-white">{Object.keys(ROLE_LABELS).map((r) => <SelectItem key={r} value={r}>{ROLE_LABELS[r]}</SelectItem>)}</SelectContent></Select>
          </div>
        ))}
      </div>
    </div>
  );
}
